// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1I49z","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__29Adx"};